<script>
	import request from './request.vue';

	const questionSchema = [
		{
			name: "id",
			displayName: "Código",
			kind: "text",
			validation: "",
			defaultSort: true,
			readOnly: true,
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "questionNumber",
			displayName: "Número da questão",
			kind: "text",
			validation: "",
			placeholder: "Digite o número",
		},
		{
			name: "statement",
			displayName: "Enunciado",
			kind: "text",
			validation: "required",
			placeholder: "Digite o enunciado",
			defaultSort: true,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "firstOption",
			displayName: "Primeira opção",
			kind: "text",
			validation: "",
			placeholder: "Sim",
		},
		{
			name: "secondOption",
			displayName: "Segunda opção",
			kind: "text",
			validation: "",
			placeholder: "Sim",
		},
		{
			name: "articleId",
			displayName: "Artigo",
			validation: "required",
			kind: "text",
			placeholder: "",
			readOnly: true,
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "rightAnswer",
			displayName: "Resposta correta",
			validation: "required",
			kind: "select",
			placeholder: "",
			options: [{
				name: "Primeira opção.",
				value: 0,
			}, {
				name: "Segunda opção.",
				value: 1,
			}],
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "idSAP",
			displayName: "IDSAP",			
			kind: "text",
			placeholder: "",
		},
	];

	export default {
		create: async function (entity) {
			const response = await request.send("testQuestion", "create", entity, true);
			return response.data;
		},
		getInfo: async function (id) {
			const response = await request.send("testQuestion", "read", { id }, true);
			return response.data;
		},
		updateInfo: async function (testQuestion) {
			let response = await request.send("testQuestion", "update", testQuestion, true);
			return response.data;
		},
		remove: async function (id) {
			return request.send("testQuestion", "delete", { id }, true);
		},
		search: async function(parameters) {
			return request.send("testQuestion", "search", parameters, true);
		},
		getSchema: function () {
			return questionSchema;
		},
	}
</script>
